


const AdvantagesBoxCollar = (): JSX.Element => {

	return (
		<div className='advantages-box'>
			
			<p>Výhody VETlímce pro&nbsp;kočky:</p>

		</div>
	);
};

export default AdvantagesBoxCollar;